export const environment = {
  production: true,
  serversIpAddress: 'https://api.dev.leste.rs:8443/',
  staticAssetsServer: 'https://api.dev.leste.rs:8443/',
  loginImagePath1: '/assets/images/LOGO-RGZ-eng.png',
  loginImagePath2: '/assets/images/LOGO-RGZ-lat.png',
  loginImagePath3: '/assets/images/LOGO-RGZ-cir.png',
  coverImagePath1: '/assets/images/Naslovna.png',
  coverImagePath2: '/assets/images/Naslovna.png',
  coverImagePath3: '/assets/images/Naslovna.png',
  coverImagePathMobile1:'/assets/images/Naslovna.png',
  coverImagePathMobile2: '/assets/images/Naslovna.png',
  coverImagePathMobile3: '/assets/images/Naslovna.png',
  //recaptchaKey: '6LerkcwqAAAAAK2IBlgL9SAQCeRoo41Ss_YxkFPX',
  recaptchaKey: '6Ld4mNwqAAAAAI_0fZMIVEFkO_p8162U7tELIlzL',
  registrationImagePath: './assets/images/FOR-logo-new.png',
  termsLogoPath: './assets/icons/RGZ-logo.png'
};
